import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import getPaymentInfo from 'widget/redux/server/actions/channel/payment';

import DataLoader from 'shared/data-components/_data-loader';


@connect(null, {
  getPaymentInfo,
})
export default class PaymentInfoLoader extends DataLoader {

  static displayName = 'PaymentInfoLoader';

  static propTypes = {
    getPaymentInfo: PropTypes.func,
    channelId: PropTypes.string,
  };

  dependencies = [
    'channelId',
  ];

  loadData() {
    const { channelId, getPaymentInfo } = this.props;

    if (!channelId) {
      return Promise.reject();
    }

    return getPaymentInfo(channelId);
  }

  get childProps() {
    return {
      isPaymentInfoFetching: this.state.isFetching,
      fetchPaymentInfo: this.loadDataDebounced,
    };
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/payment-info.js